window.initScrollSnapCarousel = (containerSelector, prevSelector, nextSelector) => {
  const container = document.querySelector(containerSelector);
  const prevButton = document.querySelector(prevSelector);
  const nextButton = document.querySelector(nextSelector);
  if (!container || !prevButton || !nextButton) return;

  const EDGE_PX = 1;

  const atStart = () => container.scrollLeft <= EDGE_PX;
  const atEnd = () =>
    container.scrollLeft + container.clientWidth >= container.scrollWidth - EDGE_PX;

  const scrollByPage = (direction) => {
    if (direction > 0 && atEnd()) {
      container.scrollTo({ left: 0, behavior: "smooth" });
      return;
    }
    if (direction < 0 && atStart()) {
      container.scrollTo({ left: container.scrollWidth, behavior: "smooth" });
      return;
    }
    container.scrollBy({ left: direction * container.clientWidth, behavior: "smooth" });
  };

  prevButton.addEventListener("click", () => scrollByPage(-1));
  nextButton.addEventListener("click", () => scrollByPage(1));
};
